import * as React from "react"
import * as s from "./PageSpinner.module.css"

/**
 * A proper loading screen — FCS-112.
 * ============================================================================
 * "Get a domain" opened a blank page with the word "Loading…" in its top corner,
 * which reads as broken for as long as the answer takes. This is the one thing
 * to show instead whenever a whole page is waiting: a spinner in the middle of
 * it, with a line saying what for.
 *
 * It is a status region, so a screen reader says what is happening, and it holds
 * the page's height so the footer does not jump up and back down when the real
 * content arrives. With reduced motion the ring stops turning and breathes
 * instead, which still says "working" without the movement.
 */
const PageSpinner = ({ label = "Loading…" }) => (
  <div className={s.wrap} role="status" aria-live="polite" data-testid="page-spinner">
    <span className={s.ring} aria-hidden="true" />
    <span className={s.label}>{label}</span>
  </div>
)

export default PageSpinner
